export class PasswordLog {
  static tableName = 'PasswordLog';
  id: string;
  dateinsert: firebase.firestore.FieldValue;
  hash: string[];
  constructor() {}
}
